export enum ExternalPaymentSolution {
    NONE = 'NONE',
    AMEX_BTA = 'AMEX_BTA',
    AIRPLUS = 'AIRPLUS',
}
